import { useState } from "react";
import Chatbot from "./Chatbot";

import chatbot from "./assets/chatbot.webp";

const styles = {
    root: {
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-end",
        gap: "12px",
        zIndex: 1000,
    },
    panel: {
        width: "360px",
        maxWidth: "90vw",
        height: "500px",
        maxHeight: "75vh",
        background: "#fff",
        borderRadius: "16px",
        boxShadow: "0 8px 30px rgba(0, 0, 0, 0.2)",
        overflow: "hidden",
        display: "flex",
        flexDirection: "column",
    },
    toggle: {
        border: "none",
        background: "transparent",
        padding: 0,
        cursor: "pointer",
        animation: "floatUpDown 2.5s ease-in-out infinite",
    },
    toggleImg: {
        // 👇 THIS is what controls the button image's size.
        // height is fixed; width is "auto" so the browser scales it
        // proportionally using the image's natural aspect ratio (no stretching).
        height: "80px",
        width: "auto",
        display: "block",
    },
};

export default function FloatingChatbot() {
    const [open, setOpen] = useState(false);

    return (
        <div style={styles.root} className="floating-chatbot-root">
            {/* inline <style> tag needed because plain inline `style={}` props
                can't define @keyframes or @media queries — this is the only
                "non-inline" bit. Positioning lives here so we can switch
                between desktop (bottom-right, panel above button) and
                mobile (top-center, panel below button) layouts. */}
            <style>
                {`
                    @keyframes floatUpDown {
                        0%   { transform: translateY(0px); }
                        50%  { transform: translateY(-8px); }
                        100% { transform: translateY(0px); }
                    }

                    /* Desktop / default: bottom-right corner, panel stacked above the button */
                    .floating-chatbot-root {
                        position: fixed;
                        bottom: 24px;
                        right: 24px;
                        left: auto;
                        top: auto;
                        transform: none;
                        flex-direction: column;
                    }

                    /* Mobile: horizontally centered, near the top, panel opens below the button */
                    @media (max-width: 768px) {
                        .floating-chatbot-root {
                            position: fixed;
                            top: 16px;
                            bottom: auto;
                            left: 50%;
                            right: auto;
                            transform: translateX(-50%);
                            align-items: center;
                            flex-direction: column-reverse;
                        }
                    }
                `}
            </style>

            {open && (
                <div style={styles.panel}>
                    <Chatbot onClose={() => setOpen(false)} />
                </div>
            )}

            <button
                style={styles.toggle}
                onClick={() => setOpen((prev) => !prev)}
                aria-label={open ? "Close chat" : "Open chat"}
            >
                <img src={chatbot} alt="" style={styles.toggleImg} />
            </button>
        </div>
    );
}
